import * as React from "react";
const HeartIcon = ({
  stroke = process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#485FA6",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={23}
    viewBox="0 0 25 23"
    fill="none"
    {...props}
  >
    <path
      d="m11.72 4.132.796 1.046.796-1.046a5.53 5.53 0 0 1 4.406-2.198c3.06 0 5.577 2.534 5.577 5.68a5.68 5.68 0 0 1-1.71 4.091l-.009.008-.007.008-9.053 9.244-9.224-9.417a5.7 5.7 0 0 1-1.556-3.934c0-3.146 2.518-5.68 5.577-5.68 1.753 0 3.364.827 4.407 2.198Z"
      stroke={stroke}
      strokeWidth={2}
    />
  </svg>
);
export default HeartIcon;
